import { postBeijing, getBeijing } from '@/http/axios/request';
 
/**
 * 上传
 */
 export function getUploadConfig(data) {
  return postBeijing({
    url: '/beijing-saas-alicloud/interior/oss/getCommonBucketTmpKey',
    data
  });
}

/**
 * 获取用户Token
 */
 export function getToken(code) { 
  return postBeijing({
    url: '/beijing-auth-iam-account/oauth/token',
    headers: {
      Authorization: `Basic MTAwMDAyOjEyMw==`
    },
    params: {
      'grant_type': 'authorization_code',
      code,
      redirect_uri: window.location.origin // 根据访问域名做为回调域名
      // redirect_uri: process.env.VUE_APP_REDIRECT_URL
    }
  });
}

/**
 * 退出登录
 */
 export function signOut() { 
  return getBeijing({
    url: '/beijing-auth-iam-account/users/signOut',
  });
}

/**
 * 根据用户名查询用户最后更新密码时间
 */
export function findLastPwdUpdate(params) { 
  return getBeijing({
    url: '/beijing-auth-iam-account/users/admin/findLastPwdUpdate',
    params
  });
}


